import ChatCanvas from "./chat-canvas";

export default ChatCanvas